// Fonte ÚNICA de verdade pra presença (cor + label) no app.
// status (inteiro em User.status):
//   0 = offline · 1 = online · 2 = ausente (away) · 3 = ocupado (busy)

import { formatDistanceToNowStrict } from "date-fns";
import { ptBR } from "date-fns/locale";

export const PRESENCE = { OFFLINE: 0, ONLINE: 1, AWAY: 2, BUSY: 3 };

const MAP = {
  0: { key: "offline", label: "Offline", color: "#9e9e9e" },
  1: { key: "online", label: "Online", color: "#44b700" },
  2: { key: "away", label: "Ausente", color: "#ffc800" },
  3: { key: "busy", label: "Ocupado", color: "#ff4545" },
};

export function getPresence(status) {
  return MAP[Number(status)] || MAP[0];
}

export const isBusy = (status) => Number(status) === PRESENCE.BUSY;

// "há 5 minutos" / "há 2 horas" a partir de um timestamp (statusUpdatedAt).
const relative = (ts) => {
  if (!ts) return null;
  const d = new Date(ts);
  if (Number.isNaN(d.getTime())) return null;
  try {
    return formatDistanceToNowStrict(d, { addSuffix: true, locale: ptBR });
  } catch {
    return null;
  }
};

// Partes da presença pra montar UI rica (label, cor, "há X", motivo).
export function presenceParts(status, { statusMessage, statusUpdatedAt } = {}) {
  const { label, color, key } = getPresence(status);
  return {
    key,
    label,
    color,
    relative: relative(statusUpdatedAt),
    reason: Number(status) === PRESENCE.BUSY ? (statusMessage || null) : null,
  };
}

// Descrição humana (string) — usada onde não dá pra montar layout.
export function describePresence(status, { statusMessage, statusUpdatedAt } = {}) {
  const s = Number(status);
  const rel = relative(statusUpdatedAt);
  if (s === PRESENCE.BUSY) {
    const base = statusMessage ? `Ocupado · ${statusMessage}` : "Ocupado";
    return rel ? `${base} (${rel})` : base;
  }
  if (s === PRESENCE.AWAY) return rel ? `Ausente ${rel}` : "Ausente";
  if (s === PRESENCE.OFFLINE) return rel ? `Offline ${rel}` : "Offline";
  return rel ? `Online ${rel}` : "Online";
}
